import React from 'react';
import AnalysisPage from './AnalysisPage'

const AlertAnalysis = () => {
    const filters = [
        {
            name: "Category",
            type: "dropdown",
            options: ["Health & Safety", "Resource Efficiency", "Service & Maintenance"],
        },
        {
            name: "Asset",
            type: "dropdown",
            options: ["HVAC", "Thermostat", "Water Heater", "Gas Meter", "Water Meter", "Electric Panel"],
        },
        {
            name: "Frequency",
            type: "button",
        },
        {
            name: "Priority",
            type: "button",
        },
        {
            name: "Type",
            type: "button",
        },
        {
            name: "Process",
            type: "button",
        },
        {
            name: "Hourly",
            type: "date",
        },
        {
            name: "Start Date",
            type: "date",
        },
        {
            name: "End Date",
            type: "date",
        },
    ];

    return (
        <AnalysisPage title="Alerts" filters={filters}></AnalysisPage>
    )
};

export default AlertAnalysis;
